// @constants
const actionTypes = require('constants/actionTypes');

const setAcordionExpandedValue = (productType) => ({
    type: actionTypes.BROKER_MY_INVESTMENTS_SET_ACORDION_EXPANDED,
    payload: {
        data: productType
    }
});

const setSelectedView = (view) => ({
    type: actionTypes.BROKER_MY_INVESTMENTS_SET_VIEW,
    payload: {
        view
    }
});

module.exports = {
    setAcordionExpandedValue,
    setSelectedView
};
